export const CafeBazaarDownloadUrl = 'https://cafebazaar.ir/app/com.khanoumi.android'
export const MykeyDownloadUrl = 'https://myket.ir/app/com.khanoumi.android'
export const IAppsDownloadUrl = 'https://iapps.ir/app/خانومی/419042849'
export const SibcheDownloadUrl = 'https://sibche.com/applications/khanoumi'
export const SibAppDownloadUrl = 'https://sibapp.com/applications/Khanoomi'
export const SibIraniDownloadUrl = 'https://sibirani.com/apps/khanoumi-com'
